var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamationMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E60046",
  d: "m15.045 20.44-.48-12.24h2.88l-.48 12.24zm-.144 4.344a1.56 1.56 0 0 1-.456-1.104q0-.624.456-1.08.48-.48 1.104-.48t1.08.48q.48.456.48 1.08t-.48 1.104a1.48 1.48 0 0 1-1.08.456q-.624 0-1.104-.456M0 0v-2h-2v2zm32 0h2v-2h-2zm0 32v2h2v-2zM0 32h-2v2h2zM0 2h32v-4H0zm30-2v32h4V0zm2 30H0v4h32zM2 32V0h-4v32z"
})));
export default SvgExclamationMark;